export const L = (lang, en, ar) => (lang === 'ar' ? ar : en);

export const DIRECTION = {
  incoming: { en: 'Incoming', ar: 'وارد', cls: 'bg-sky-100 text-sky-700 border-sky-200' },
  outgoing: { en: 'Outgoing', ar: 'صادر', cls: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
};

export const STATUS = {
  new: { en: 'New', ar: 'جديد', cls: 'bg-[#2563eb]/10 text-[#2563eb] border-[#2563eb]/25' },
  in_progress: { en: 'In progress', ar: 'قيد المتابعة', cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  closed: { en: 'Closed', ar: 'مُغلق', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
};

export const ENTITY_TYPE = {
  ministry: { en: 'Ministry', ar: 'وزارة' }, government: { en: 'Government dept.', ar: 'دائرة حكومية' },
  freezone: { en: 'Free zone', ar: 'منطقة حرة' }, bank: { en: 'Bank', ar: 'بنك' }, court: { en: 'Court', ar: 'محكمة' },
  client: { en: 'Client', ar: 'عميل' }, supplier: { en: 'Supplier', ar: 'مورّد' }, other: { en: 'Other', ar: 'أخرى' },
};

export const CATEGORY = {
  license: { en: 'License', ar: 'رخصة' }, visa: { en: 'Visa', ar: 'تأشيرات' }, tax: { en: 'Tax / VAT', ar: 'ضرائب' },
  bank: { en: 'Banking', ar: 'بنكي' }, legal: { en: 'Legal', ar: 'قانوني' }, contract: { en: 'Contract', ar: 'عقود' },
  hr: { en: 'HR', ar: 'موارد بشرية' }, compliance: { en: 'Compliance', ar: 'امتثال' }, other: { en: 'Other', ar: 'أخرى' },
};

export const label = (map, key, lang) => map[key]?.[lang === 'ar' ? 'ar' : 'en'] || key;
export const fmtSize = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${(n / 1024).toFixed(0)} KB`);

export const Pill = ({ map, value, lang, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-medium ${map[value]?.cls || 'bg-slate-100 text-slate-600 border-slate-200'}`}>
    {label(map, value, lang)}
  </span>
);

export const inputCls = 'w-full h-9 px-3 rounded-md bg-white border border-[#e5e7eb] text-sm text-[#111827] focus:outline-none focus:ring-2 focus:ring-[#2563eb]/30';
export const Field = ({ label: l, children, className = '' }) => (
  <div className={className}>
    <label className="text-[10px] uppercase tracking-widest text-[#2563eb] font-bold block mb-1">{l}</label>
    {children}
  </div>
);
